import { render, staticRenderFns } from "./MarketPlace.vue?vue&type=template&id=6168aa7d&scoped=true"
import script from "./MarketPlace.vue?vue&type=script&lang=js"
export * from "./MarketPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168aa7d",
  null
  
)

export default component.exports